import React, { Component } from "react";
import PropTypes from "prop-types";
import { initIronSource, adBlockerPopup } from "../../utils/ironsource";

class IronSourceInitializer extends Component {

  constructor(props){
		super(props);

		this.state = {
			ironSourceStaleVideo : false
		}

    this.staleVideoTimer = null;
  }
  
  setIronSourceStaleTimer(delay) {
		const self = this;

		console.log('Ironsource: timer', delay);
		window.clearTimeout(self.staleVideoTimer);
		self.staleVideoTimer = window.setTimeout(() => {
			console.log('Ironsource: triggered timer', delay);
			self.setState({ironSourceStaleVideo: true});
			// self.props.rewardVideo.updateRewardVideoStale(true);
		}, delay);
	}

	initIronSource() {
    const IronRV = window.IronRV;
    
		const ironrv = initIronSource(
			[{
				name: IronRV.EVENTS.AD_BLOCK,
				callback: this.props.rewardVideoAdBlocked,
			},{
				name: IronRV.EVENTS.NO_CAMPAIGNS,
				callback: this.props.rewardVideoReady,
			},{
				name: IronRV.EVENTS.READY,
				callback: this.props.rewardVideoReady,
			},{
				name: IronRV.EVENTS.RESIZE,
				callback: null
			},{
				name: IronRV.EVENTS.OPEN,
				callback: this.props.rewardVideoOpen
			},{
				name: IronRV.EVENTS.CLOSE,
				callback: this.props.rewardVideoOpen
			},{
				name: IronRV.EVENTS.COMPLETION,
				callback: this.props.rewardVideoComplete
			}]
		);

		this.setState({ironSourceStaleVideo: false});

		this.props.setRewardVideoSupport();
		this.props.setIronRV(ironrv);
  }
  
  componentDidMount() {
    this.initIronSource();
  }

  componentDidUpdate(prevProps, prevState ) {
    console.log('[IronSourceInitializer] ironsource: ', prevProps, this.props, prevState, this.state);
		const inventoryDoesNotExist = this.props.rewardVideo.ready !== prevProps.rewardVideo.ready && this.props.rewardVideo.ready === false;
		const inventoryStale = this.state.ironSourceStaleVideo !== prevState.ironSourceStaleVideo && this.state.ironSourceStaleVideo === true;
    const inventoryExist = this.props.rewardVideo.ready !== prevProps.rewardVideo.ready && this.props.rewardVideo.ready === true;
    
    if (this.props.rewardVideo.adBlocked) {
			adBlockerPopup(this.props.rewardVideo.ironRV);
		}

		if ( inventoryDoesNotExist ) {
			this.props.rewardVideoReady(null); //reset to default
			this.setIronSourceStaleTimer(30 * 1000);
		}

		if (inventoryExist) {
			this.setIronSourceStaleTimer(15 * 60 * 1000);
		}

		if (inventoryStale) {
			this.initIronSource();
		}
  }

  render() {
    return null;
  }
}

// Btn.propTypes = {
//   onClick: PropTypes.func.isRequired,
//   btnRef: PropTypes.object,
//   btnClassName: PropTypes.string,
//   label: PropTypes.string
// };

export default IronSourceInitializer;



// WEBPACK FOOTER //
// ./src/js/components/ironsource/IronSourceInitializer.jsx